import "../Login/style.css";
import "../ForgotPassword/style.css";
import "./style.css";
import "swiper/css";
import "swiper/css/pagination";
import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { failed, success } from "@components/Common/Toastify";
import { verifyEmailOtp, resendOtp } from "../../API/Auth";
import lefticon from "../../Assets/Images/left.png";
import "../OtpVerifySuccessfull/OtpVerifySuccessfull"
import storage from "@utils/storage";

const VerifyEmailOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const savedUser = storage.getUserType();
  const email =
    location?.state?.email ||
    searchParams.get("email") ||
    savedUser?.email ||
    location?.state?.userData?.email ||
    "";
  const autoOtp = searchParams.get("otp") || "";
  const urlUserType = searchParams.get("userType") || "";
  const roleType =
    location?.state?.roleType ||
    savedUser?.userType ||
    urlUserType;
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
  const [btnLoading, setBtnLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [, setSelectedUserType] = useState<"borrower" | "lender">("borrower");
  const effectRan = useRef(false);
  const [showForm, setShowForm] = useState(() => {
    return !(email && autoOtp && /^\d{6}$/.test(autoOtp));
  });

  useEffect(() => {
    if (effectRan.current) return;
    effectRan.current = true;

    if (email && autoOtp && /^\d{6}$/.test(autoOtp)) {
      setShowForm(false); // Hide form while verifying
      (async () => {
        setBtnLoading(true);
        try {
          const payload = { email, otp: autoOtp, userType: roleType };
          const res: any = await verifyEmailOtp(payload);
          const message = res?.data?.message?.toLowerCase();

          if (message.includes("email already verified")) {
            navigate("/auth/email-verify-successfully", { state: { status: "already_verified", roleType } });
          } else if (message.includes("email verified successfully")) {
            navigate("/auth/email-verify-successfully", { state: { status: "success", roleType } });
          } else {
            setShowForm(true); // Show form if not redirected
          }
        } catch {
          setShowForm(true); // Show form on error
        } finally {
          setBtnLoading(false);
        }
      })();
    }
  }, [email, autoOtp, navigate, roleType]);

  useEffect(() => {
    const loginPage = document.querySelector(".onboarding-page");
    if (loginPage) {
      loginPage.classList.remove("theme-borrower", "theme-lender");
      loginPage.classList.add(`theme-${roleType}`);
    }
  }, [roleType]);

  useEffect(() => {
    if (urlUserType === "borrower" || urlUserType === "lender") {
      setSelectedUserType(urlUserType);
    }
  }, [urlUserType]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (!/^\d{6}$/.test(otpValue)) {
      failed("Please enter a valid 6-digit OTP.");
      return;
    }
    if (!email) {
      failed("Email address not found. Please try logging in again.");
      return;
    }

    setBtnLoading(true);
    try {
      const payload = { email, otp: otpValue, userType: roleType };
      const res: any = await verifyEmailOtp(payload);
      success(res?.data?.message || "Email Verified Successfully");
      navigate("/auth/email-verify-successfully", { state: { status: "success", roleType } });
    } catch (err: any) {
      failed(err?.response?.data?.message || "Invalid OTP.");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleResendOtp = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (!email) {
      failed("Email address not found. Please try logging in again.");
      return;
    }
    setResendLoading(true);
    try {
      const payload = { email, userType: roleType };
      const res: any = await resendOtp(payload);
      success(res?.data?.message || "OTP Resent Successfully");
    } catch (err: any) {
      failed(err?.response?.data?.message || "Failed to resend OTP.");
    } finally {
      setResendLoading(false);
    }
  };

  if (!showForm) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Verifying...</span>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div
        className={`row onboarding-page fg-pw theme-${roleType || "borrower"} verify-email-otp-page`}
      >
        <div className="p-0 d-flex flex-column align-items-center my-3">
          <div className="login-btn-call align-items-center d-flex justify-content-between">
            <div className="return-home">
              <Link
                to="/auth/signup"
                state={{ roleType }}
                className="return text-decoration-none align-items-center d-flex"
              >
                <img src={lefticon} alt="back" className="img-fluid back" />
                <span className="ms-2 text-decoration-none">Back</span>
              </Link>
            </div>
          </div>

          <div className="lower-div">
            <div className="credentials-box otp-section">
                <div className="heading-para-block">
                  <h2 className="text-center">Enter Email Verification Code</h2>
                  <p className="text-center">
                    We have sent a 6-digit code to <strong>{email}</strong>
                  </p>
                </div>

                <div className="d-flex justify-content-center mb-4 otp-block">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      className="form-control text-center otp-box"
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
                </div>

                <div className="verify-btn">
                  <button
                    type="submit"
                    className="btn btn-borrower signin w-100"
                    disabled={btnLoading}
                  >
                    {btnLoading ? "Verifying..." : "Verify"}
                  </button>
                </div>

                <div className="dont-have-acc text-center">
                  Did not receive the verification code?{" "}
                  <a className="signup" onClick={handleResendOtp}>
                    {resendLoading ? "Resending..." : "Resend Code"}
                  </a>
                </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default VerifyEmailOtp;

